export default __webpack_public_path__ + "static/media/plant.c9d382ae.jpeg";